import { useState, useRef, useEffect } from 'react'
import * as HiIcons from 'react-icons/hi'
import styled from 'styled-components'
import useTranslation from '../../hooks/useTranslation'
import { TextControl } from './Core'
import { AppIconColor } from '../../styles/IconStyle'

const SearchInputWrapper = styled.div`
    display: flex;
    height: 42px;
    -webkit-box-align: center;
    align-items: center;
    
    @media (max-width: 560px) {
        margin-left: 0.25rem;
    }
`

const SButton = styled.button`
    display: inline-flex;
    width: auto;
    max-width: 100%;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    white-space: nowrap;
    font-family: "Euclid Circular B", sans-serif;
    cursor: pointer;
    transition-property: background-color, color, border, box-shadow, transform;
    transition-duration: 0.1s;
    transition-timing-function: ease-out;
    border-radius: 4px;
    min-width: 40px;
    height: 40px;
    padding: 8px 16px;
    font-size: 14px;
    line-height: 24px;
    border: none;
    background-color: transparent;
    color: ${({theme}) => theme.font.color}; ;
    font-weight: 400;
    &:hover{
        background-color: rgba(167, 169, 180, 0.25); 
    }
    &:active{
        background-color: ${ ({theme}) => theme.form.background}
    }
`

const IconWrapper = styled.figure`
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    margin: 0rem 0.5rem 0 0;
    `

const SearchIcon = styled(HiIcons.HiSearch)`
    max-width: 1.5rem;
    display: inline;
    margin-right: 0rem;
    margin-top: 0rem;
    padding: 0;
    &:hover{
        opacity: 80%;
        cursor: pointer;
    }
`

export const SearchButton = ({ searchTerm, setSearchTerm, searchLabel, searchPlaceholder, testId }) => {
    const [active, setActive] = useState(Boolean(searchTerm))
    const searchFieldRef = useRef()

    const {t} = useTranslation()

    function handleSearch(event) {
        event.preventDefault();
        const { value } = event.target;
        setSearchTerm(value);
    }

    //If state is active, search input Field is visible so set the focus to it.
    useEffect(() => {
        if (active) { searchFieldRef.current.focus() }
    }, [active])

    // Keep input open while there's a search term (avoid collapsing during refetch/rerenders)
    useEffect(() => {
        if (searchTerm) setActive(true)
    }, [searchTerm])

    return (
        <AppIconColor >
            <SearchInputWrapper name='searchInputWrapper'>
                {!active &&
                    <SButton onClick={(e) => {
                        setActive(true)
                    }} data-testid={testId}>
                        <IconWrapper>
                            <SearchIcon />
                        </IconWrapper>
                        {t(searchPlaceholder)}
                    </SButton>}
                {/*
                  * The same test id as the collapsed button above, never both at
                  * once — the two are mutually exclusive branches, so a lookup
                  * still finds exactly one element.
                  *
                  * The id used to be on the button alone, which meant a list
                  * search could be used once and then never again: typing opens
                  * the input, the button unmounts, and the id goes with it. A
                  * spec that searched twice failed on the second `clear` with
                  * "never found it", on a page where the search box was plainly
                  * on screen holding the first term.
                  */}
                {active ? <TextControl ref={searchFieldRef} type='text' name='SearchButton' data-testid={testId} value={searchTerm || ''} onBlur={(e) => { if (!e.currentTarget.value) setActive(false) }} onChange={handleSearch} onKeyDown={(e) => { if (e.key === 'Escape') setActive(false) }} placeholder={t(searchLabel)} /> : <></>}
            </SearchInputWrapper>
        </AppIconColor>
    )
}
